import styled from "styled-components";

export const InputWrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const Input = styled.input`
    flex: 1;
    appearance: unset;
    color: var(--text-color-primary);
    font-size: 16px;
    border: 1px solid var(--border-color);
    outline: 1px solid transparent;
    border-radius: 10px;
    background-color: var(--theme-color-secondary);
    padding: 14px 12px;
    transition: all ease-in-out 0.3s;

    &::placeholder {
        color: var(--text-color-secondary);
        opacity: 0.6;
        font-size: 14px;
    }

    &:focus {
        border-color: var(--theme-color-primary);
        outline-color: var(--theme-color-primary);
    }

    &:disabled {
        cursor: not-allowed;
        color: var(--text-color-secondary);
    }

    &.password {
        padding-right: 40px;
    }
`;

export const EyeButton = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 12px;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-color-secondary);
    margin: auto;

    svg {
        width: 100%;
        height: auto;
    }
`;